import { render, staticRenderFns } from "./ReportsTableBasic.vue?vue&type=template&id=a8235502&"
import script from "./ReportsTableBasic.vue?vue&type=script&lang=js&"
export * from "./ReportsTableBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports